type RouteTracePayload = Record<string, unknown>;

declare global {
  interface Window {
    __ZAPPY_ROUTE_TRACE__?: Array<{
      at: number;
      label: string;
      route: string;
      payload: RouteTracePayload;
    }>;
  }
}

const TRACE_STORAGE_KEY = "zappy:route-debug";
const MAX_TRACE_EVENTS = 300;

const isRouteTraceEnabled = () => {
  if (typeof window === "undefined") return false;
  if (import.meta.env.DEV) return true;
  return window.localStorage.getItem(TRACE_STORAGE_KEY) === "1";
};

export const traceRouteEvent = (
  label: string,
  route: string,
  payload: RouteTracePayload = {}
) => {
  if (!isRouteTraceEnabled()) return;

  const event = {
    at: Math.round(performance.now()),
    label,
    route,
    payload,
  };

  const buffer = window.__ZAPPY_ROUTE_TRACE__ ?? [];
  buffer.push(event);
  if (buffer.length > MAX_TRACE_EVENTS) buffer.splice(0, buffer.length - MAX_TRACE_EVENTS);
  window.__ZAPPY_ROUTE_TRACE__ = buffer;

  console.debug(`[route-trace] ${label}`, event);
};

export const getRouteTraceSnapshot = () => {
  if (typeof window === "undefined") return [];
  return window.__ZAPPY_ROUTE_TRACE__ ?? [];
};
